<template>
    <EmptyContentSection icon="thumbup" :title="title" :description="description">
        <template #action>
            <ClientOnly v-if="editMode">
                <VJoyButton icon="add" size="small" variant="secondary" data-testid="open-recommendation-request" @click="openEditRecommendation">
                    {{ t('profile.section.header.recommendations.ask.label') }}
                </VJoyButton>
                <template #fallback>
                    <VJoyFormFieldSkeleton size="small" width="250px" />
                </template>
            </ClientOnly>
            <VJoyButton v-else icon="add" size="small" variant="secondary" data-testid="add-recommendation" @click="emit('open-add-recommendation')">
                {{ t('profile.section.recommendation.empty.visitor.button.label', {0: profile?.firstname}) }}
            </VJoyButton>
        </template>
    </EmptyContentSection>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyButton, VJoyFormFieldSkeleton} from '@maltjoy/core-vue';
    import EmptyContentSection from '~/components/section/EmptyContentSection.vue';
    import {eventBus} from '~/config/events';
    import {RecommendationRequestStartedEntryPoint} from '~/config/TrackingEvents';
    import {useProfileStore} from '~/store/profileStore';

    const props = defineProps<{
        editMode?: boolean;
    }>();

    const emit = defineEmits(['open-add-recommendation']);

    const {t} = useTranslation();
    const {profile} = storeToRefs(useProfileStore());

    const title = computed(() =>
        props.editMode
            ? t('profile.section.recommendation.empty.title')
            : t('profile.section.recommendation.empty.visitor.title', {0: profile.value?.firstname}),
    );

    const description = computed(() =>
        props.editMode ? t('profile.section.recommendation.empty.description') : t('profile.section.recommendation.empty.visitor.description'),
    );

    function openEditRecommendation() {
        eventBus.emit('recommendations:edit-mode', {entryPoint: RecommendationRequestStartedEntryPoint.SECTION_EDIT});
    }
</script>
